import { useId } from "react";
import { TONE_CLASSES, TONE_DOT, statusTone } from "@/lib/format";

export default function StatusBadge({ status, tone, testId }) {
  const t = tone || statusTone(status);
  const uid = useId().replace(/:/g, "");
  const statusSlug = String(status || "unknown").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
  return (
    <span
      data-testid={testId || `status-badge-${statusSlug}-${uid}`}
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2.5 py-1 text-[10px] font-semibold uppercase ${TONE_CLASSES[t]}`}
      style={{ letterSpacing: "0.07em" }}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${TONE_DOT[t]}`} />
      {status}
    </span>
  );
}
